// extracted by mini-css-extract-plugin
export default {"formContainer":"CustomerIOForm-module--formContainer--7ea4c","response":"CustomerIOForm-module--response--b2f41"};